import { useTranslation } from "react-i18next";
import "./Menutab.css";
import { useEffect, useRef, useState } from "react";



export default function ImageTabs() {
  const [activeIndex, setActiveIndex] = useState(0);
  const tabRefs = useRef([]);
  const indicatorRef = useRef(null);
  const { t } = useTranslation();

  const TABS = [
  { label: t("menu_label1"), images: [t("menu11_no"), t("menu12_no"), t("menu13_no"), t("menu14_no"), t("menu15_no"), "/images/drinks1.png", "/images/drinks2.png", "/images/drinks3.png", "/images/drinks4.png", "/images/drinks5.png"] },
  { label: t("menu_label2"), images: [t("menu1_no"), t("menu2_no")] },
  { label: t("menu_label3"), images: [t("menu3_no"), t("menu4_no")] },
  { label: t("menu_label4"), images: [t("menu5_no"), t("menu6_no")] },
  { label: t("menu_label5"), images: [t("menu7_no"), t("menu8_no")] },
  { label: t("menu_label6"), images: [t("menu9_no"), t("menu10_no")] },
  { label: t("menu_label7"), images: ["/images/drinks1.png", "/images/drinks2.png", "/images/drinks3.png", "/images/drinks4.png", "/images/drinks5.png"] },
];

  useEffect(() => {
    const currentTab = tabRefs.current[activeIndex];
    if (!currentTab) return;

    const { offsetLeft, offsetWidth } = currentTab;

    indicatorRef.current.style.transform = `translateX(${offsetLeft}px)`;
    indicatorRef.current.style.width = `${offsetWidth}px`;
  }, [activeIndex]);

  const handleClick =() =>{
    if(window.innerWidth <= 700){
       const y = document.getElementById("menu_images").getBoundingClientRect().top + window.pageYOffset -110;
    window.scrollTo({
      top: y,
      behavior: "smooth",
    });
    }
  }

  return (
    <div className="tabs-container" id="menu">
      {/* TAB BAR */}
      <div className="tabs-wrapper">
        {TABS.map((tab, index) => (
          <button
            key={tab.label}
            ref={(el) => (tabRefs.current[index] = el)}
            className={`tab-btn ${activeIndex === index ? "active" : ""}`}
            onClick={() => {
              setActiveIndex(index);
              handleClick();
            }}
          >
            {tab.label}
          </button>
        ))}

        {/* SLIDING INDICATOR */}
        <span ref={indicatorRef} className="tab-indicator" />
      </div>

      {/* FULL WIDTH LINE */}
      <div className="tabs-line" />

      {/* IMAGES */}
      <div className="images-grid" id="menu_images">
        {TABS[activeIndex].images.map((img, i) => (
          <img key={i} src={img} alt="menu" />
        ))}
      </div>
    </div>
  );
}
